export default __webpack_public_path__ + "static/media/1128040325510263.82f2a65a.jpg";